export function useSingleLayer() {
    const pageOverlayHandler = usePageOverlay();
    const layerId = ref<string>();
    const close = () => {
        if (!layerId.value) {
            return;
        }
        pageOverlayHandler.closeLayer({ layerId: layerId.value });
        layerId.value = undefined;
    };
    const open = <T extends Component>(args: { component: T; props: any }) => {
        if (layerId.value) {
            close();
        } else {
            layerId.value = pageOverlayHandler.addLayer({
                component: markRaw(args.component),
                props: {
                    onClose: close,
                    ...args.props,
                },
            });
        }
    };
    return { open, close };
}
